export const DATE_PICKER_PERIOD = [
  { unit: 'week', period: 'current' },
  { unit: 'week', period: 'previous' },
  { unit: 'month', period: 'current' },
  { unit: 'month', period: 'previous' },
  { unit: 'year', period: 'current' },
  { unit: 'year', period: 'previous' },
];

export const INBOX_DATE_PICKER_PERIOD = [
  { unit: 'day', period: 'current' },
  { unit: 'day', period: 'previous' },
  { unit: 'week', period: 'current' },
  { unit: 'week', period: 'previous' },
  { unit: 'month', period: 'current' },
  { unit: 'month', period: 'previous' },
];

export const BI_DATE_PICKER_PERIOD = [
  { unit: 'ytd', period: 'current' },
  { unit: '12months', period: 'previous' },
  { unit: 'week', period: 'current' },
  { unit: 'week', period: 'previous' },
  { unit: 'month', period: 'current' },
  { unit: 'month', period: 'previous' },
  { unit: 'year', period: 'current' },
  { unit: 'year', period: 'previous' },
];
